// extracted by mini-css-extract-plugin
export default {"mainContent":"AdminLayout_mainContent__BOruO","expanded":"AdminLayout_expanded__zH2KM"};